const jellyNavItems = [
  { to: '/jelly', label: 'Dashboard' },
  { to: '/jelly/levels', label: 'Game Levels' },
];

export default jellyNavItems;
